// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chatbot-container {
  position: fixed;
  bottom: 1rem;
  right: 1rem;
  z-index: 999999;
  contain: style;
}

.chatbot-message {
  margin: 0.2rem 0;
  padding: 20px;
  border-radius: 10px;
  max-width: 75%;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  /* Subtle shadow for depth */
  word-wrap: break-word;
  position: relative;
  background-color: #f1f1f3;

  cursor: pointer;


  p {
    margin: 0;
    font-size: 14px;
    color: black;
  }

}

.chatbot-message-container {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-right: .5rem;

  font-family: 'Inter', sans-serif;
  font-weight: 425;

}

.chatbot-message-close-button {
  position: absolute;
  right: -.65rem;
  top: -.8rem;
  z-index: 1000000;
  padding: .25rem;
  background-color: #e5e5ea;
  border-radius: 50%;
  cursor: pointer;
  width: 1.5rem;
  height: 1.5rem;

  svg {
    width: 1rem;
    height: 1rem;
  }

}

.chatbot-bubble {
  width: 60px;
  height: 60px;
  background-size: cover;
  background-position: center;
  overflow: hidden;
  border-radius: 50%;
  border: none;
  cursor: pointer;
  margin-top: .5rem;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  float: inline-end;
  z-index: 1000000;

  svg {
    padding-top: .25rem;
  }

  &:hover {
    transform: scale(1.05);
  }
}

.chatbot-window {
  width: calc(100vw - 69%);
  height: calc(100vh - 25%);
  min-width: 500px;
  max-width: 800px;
  overflow: hidden;
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 10px;
  padding: .25rem;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  position: fixed;
  bottom: calc(1rem + 65px);
  right: 1rem;
  transition: all 0.3s ease;
  transform-origin: bottom right;
  z-index: 999998;
}

.chatbot-window.closed {
  transform: translateY(100%);
  opacity: 0;
  pointer-events: none;
}

.chatbot-window.open {
  transform: translateY(0);
  opacity: 1;
  pointer-events: auto;
}

.chatbot-window iframe {
  width: 100%;
  height: 100%;
  border: none;
}

@media (max-width: 768px) {
  .chatbot-window {
    width: 100vw;
    min-width: 100vw;
    height: calc(100vh - 75px);
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 0;
    padding: 0;
    transition: none;
    min-width: none;
    /* Disable the grow animation for mobile */
  }

  .chatbot-container {
    bottom: .5rem;
    right: .5rem;
  }

  .chatbot-window.closed {
    transform: translateY(100%);
    opacity: 0;
  }

  .chatbot-window.open {
    transform: translateY(0);
    opacity: 1;
  }

  .chatbot-window {
    animation: slide-up 0.3s ease;
  }

  @keyframes slide-up {
    0% {
      transform: translateY(100%);
    }

    100% {
      transform: translateY(0);
    }
  }

  .chatbot-bubble {
    z-index: 1000000;
  }

  .chatbot-message-container {
    display: none;
  }
}

@media (min-width: 769px) {
  @keyframes grow {
    0% {
      transform: scale(0);
    }

    100% {
      transform: scale(1);
    }
  }

  .chatbot-window {
    animation: grow 0.3s ease;
  }

  .chatbot-window.closed {
    transform: scale(0);
    opacity: 0;
  }

  .chatbot-window.open {
    transform: scale(1);
    opacity: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Chatbot/Chatbot.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,wCAAwC;EACxC,4BAA4B;EAC5B,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;;EAEzB,eAAe;;;EAGf;IACE,SAAS;IACT,eAAe;IACf,YAAY;EACd;;AAEF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,mBAAmB;;EAEnB,gCAAgC;EAChC,gBAAgB;;AAElB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,cAAc;;EAEd;IACE,WAAW;IACX,YAAY;EACd;;AAEF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,2BAA2B;EAC3B,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,wCAAwC;EACxC,iBAAiB;EACjB,gBAAgB;;EAEhB;IACE,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,wCAAwC;EACxC,eAAe;EACf,yBAAyB;EACzB,WAAW;EACX,yBAAyB;EACzB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;EACxB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE;IACE,YAAY;IACZ,gBAAgB;IAChB,0BAA0B;IAC1B,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,gBAAgB;IAChB,UAAU;IACV,gBAAgB;IAChB,eAAe;IACf,0CAA0C;EAC5C;;EAEA;IACE,aAAa;IACb,YAAY;EACd;;EAEA;IACE,2BAA2B;IAC3B,UAAU;EACZ;;EAEA;IACE,wBAAwB;IACxB,UAAU;EACZ;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE;MACE,2BAA2B;IAC7B;;IAEA;MACE,wBAAwB;IAC1B;EACF;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE;MACE,mBAAmB;IACrB;;IAEA;MACE,mBAAmB;IACrB;EACF;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,mBAAmB;IACnB,UAAU;EACZ;;EAEA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF","sourcesContent":[".chatbot-container {\n  position: fixed;\n  bottom: 1rem;\n  right: 1rem;\n  z-index: 999999;\n  contain: style;\n}\n\n.chatbot-message {\n  margin: 0.2rem 0;\n  padding: 20px;\n  border-radius: 10px;\n  max-width: 75%;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n  /* Subtle shadow for depth */\n  word-wrap: break-word;\n  position: relative;\n  background-color: #f1f1f3;\n\n  cursor: pointer;\n\n\n  p {\n    margin: 0;\n    font-size: 14px;\n    color: black;\n  }\n\n}\n\n.chatbot-message-container {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  margin-right: .5rem;\n\n  font-family: 'Inter', sans-serif;\n  font-weight: 425;\n\n}\n\n.chatbot-message-close-button {\n  position: absolute;\n  right: -.65rem;\n  top: -.8rem;\n  z-index: 1000000;\n  padding: .25rem;\n  background-color: #e5e5ea;\n  border-radius: 50%;\n  cursor: pointer;\n  width: 1.5rem;\n  height: 1.5rem;\n\n  svg {\n    width: 1rem;\n    height: 1rem;\n  }\n\n}\n\n.chatbot-bubble {\n  width: 60px;\n  height: 60px;\n  background-size: cover;\n  background-position: center;\n  overflow: hidden;\n  border-radius: 50%;\n  border: none;\n  cursor: pointer;\n  margin-top: .5rem;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  float: inline-end;\n  z-index: 1000000;\n\n  svg {\n    padding-top: .25rem;\n  }\n\n  &:hover {\n    transform: scale(1.05);\n  }\n}\n\n.chatbot-window {\n  width: calc(100vw - 69%);\n  height: calc(100vh - 25%);\n  min-width: 500px;\n  max-width: 800px;\n  overflow: hidden;\n  background-color: white;\n  border: 1px solid #ccc;\n  border-radius: 10px;\n  padding: .25rem;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  position: fixed;\n  bottom: calc(1rem + 65px);\n  right: 1rem;\n  transition: all 0.3s ease;\n  transform-origin: bottom right;\n  z-index: 999998;\n}\n\n.chatbot-window.closed {\n  transform: translateY(100%);\n  opacity: 0;\n  pointer-events: none;\n}\n\n.chatbot-window.open {\n  transform: translateY(0);\n  opacity: 1;\n  pointer-events: auto;\n}\n\n.chatbot-window iframe {\n  width: 100%;\n  height: 100%;\n  border: none;\n}\n\n@media (max-width: 768px) {\n  .chatbot-window {\n    width: 100vw;\n    min-width: 100vw;\n    height: calc(100vh - 75px);\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    border-radius: 0;\n    padding: 0;\n    transition: none;\n    min-width: none;\n    /* Disable the grow animation for mobile */\n  }\n\n  .chatbot-container {\n    bottom: .5rem;\n    right: .5rem;\n  }\n\n  .chatbot-window.closed {\n    transform: translateY(100%);\n    opacity: 0;\n  }\n\n  .chatbot-window.open {\n    transform: translateY(0);\n    opacity: 1;\n  }\n\n  .chatbot-window {\n    animation: slide-up 0.3s ease;\n  }\n\n  @keyframes slide-up {\n    0% {\n      transform: translateY(100%);\n    }\n\n    100% {\n      transform: translateY(0);\n    }\n  }\n\n  .chatbot-bubble {\n    z-index: 1000000;\n  }\n\n  .chatbot-message-container {\n    display: none;\n  }\n}\n\n@media (min-width: 769px) {\n  @keyframes grow {\n    0% {\n      transform: scale(0);\n    }\n\n    100% {\n      transform: scale(1);\n    }\n  }\n\n  .chatbot-window {\n    animation: grow 0.3s ease;\n  }\n\n  .chatbot-window.closed {\n    transform: scale(0);\n    opacity: 0;\n  }\n\n  .chatbot-window.open {\n    transform: scale(1);\n    opacity: 1;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
